export default "__VITE_ASSET__alfkdh0s__"